import React from "react";
import { IconProp } from ".";
export default function BoltIcon(props: IconProp) {
    const { width = 24, height = 24, color = "black" } = props;
    return (
        <svg width={width} height={height} viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.4425 47.906H17.9299C16.2898 47.906 15.0799 47.1793 14.3002 45.7259C13.5204 44.2725 13.6064 42.8576 14.5582 41.4812L39.7847 5.15471C40.3857 4.31912 41.1627 3.74547 42.1156 3.43374C43.0686 3.12207 44.0254 3.14946 44.9862 3.51591C45.947 3.88232 46.6837 4.50176 47.1965 5.37424C47.7092 6.24677 47.8997 7.19246 47.7679 8.21129L45.1705 29.178H56.1599C57.9026 29.178 59.1382 29.9578 59.8666 31.5174C60.595 33.0769 60.3917 34.5303 59.2566 35.8777L31.6741 69.0805C31.0217 69.8648 30.2263 70.3598 29.2879 70.5653C28.3494 70.7709 27.4222 70.6792 26.5062 70.2904C25.5901 69.9017 24.8919 69.2766 24.4115 68.4153C23.9311 67.554 23.7568 66.6285 23.8886 65.6386L26.4425 47.906Z"
                fill={color}
            />
        </svg>
    );
}
